<div
  class="flex w-full flex-col gap-4 overflow-hidden rounded-2xl border border-gray-200"
>
  <div
    class="flex h-full flex-col gap-2 overflow-hidden rounded-md bg-white p-4"
  >
    @if (showHeader()) {
      <div class="flex items-center justify-between">
        <div class="flex flex-col gap-2">
          <div class="text-xl font-bold">
            <ng-content select="[title]"></ng-content>
          </div>
          <div class="font-medium">
            <ng-content select="[subtitle]"></ng-content>
          </div>
        </div>
        <ng-content select="[actions]"></ng-content>
      </div>

      <div class="border-accent-300 flex h-1 w-full border-t-[1px]"></div>
    }

    <ng-content select="[content]"></ng-content>
  </div>
</div>
